const RDV_WHATSAPP_TEXT = encodeURIComponent(
  "Bonjour, je viens de découvrir votre site, j'aimerais prendre rendez-vous"
);

/** Prise de rendez-vous WhatsApp — Sénégal (Pikine). */
export const WHATSAPP_RDV_SN_URL =
  `https://wa.me/221782707350?text=${RDV_WHATSAPP_TEXT}`;

/** Prise de rendez-vous WhatsApp — Mauritanie (Nouakchott). */
export const WHATSAPP_RDV_MR_URL =
  `https://wa.me/22241495812?text=${RDV_WHATSAPP_TEXT}`;

/** Alias historique : Sénégal. */
export const WHATSAPP_RDV_URL = WHATSAPP_RDV_SN_URL;

export const RDV_BUTTONS = [
  {
    country: "SN",
    label: "Prendre RDV 🇸🇳",
    href: WHATSAPP_RDV_SN_URL,
  },
  {
    country: "MR",
    label: "Prendre RDV 🇲🇷",
    href: WHATSAPP_RDV_MR_URL,
  },
] as const;
